@let hasErrorValue = hasError();

<rt-box layout-vertical [class.question-card__box--invalid]="hasErrorValue">
  <rt-form-field>
    <div class="question-card__header">
      <rt-evaluation-field-label
        [title]="title()"
        [hint]="hint()"
        [required]="required()"
        [filled]="filled()"
      />

      @if (canComment() && !commentExpanded()) {
        <div class="question-card__comment-wrap">
          <rt-icon-button
            class="question-card__comment-btn"
            variant="plain"
            size="small"
            shape="square"
            iconName="comment"
            [rtTooltip]="'app.evaluation_panel.add_comment_tooltip' | translate"
            (click)="commentToggle.emit()"
          />
          @if (commentDiscovery()) {
            <rt-dot class="question-card__comment-dot" color="tellent" [pulse]="true" />
          }
        </div>
      }
    </div>

    <ng-content />
  </rt-form-field>

  <ng-content select="[questionNote]" />
</rt-box>

@if (hasErrorValue) {
  <div class="question-card__error">
    @if (control().hasError('pattern')) {
      {{ 'app.evaluation_panel.errors.invalid_number' | translate }}
    } @else {
      {{ 'app.evaluation_panel.errors.basic_required' | translate }}
    }
  </div>
}
